export const AUTHORIZATION_GROUP = {
  GESOP: 'f1a92491-ee0c-40f1-adef-c05c9977753d',
  INFOR: '8f87cec6-c00b-41bc-8d5f-920fe7e662de',
  MONTREAL: '7b9ae7fe-b1bb-41ee-acc3-94c0e4e378ab',
  STEFANINI: '43cb7e1c-07a4-4cce-bb70-4ca8761992d6',
  FFI_TERCEIRIZADOS: 'd398a4f0-aa82-44f0-9e36-8d74331b3179'
} as const;

export const MAINTENANCE_GROUP_IDS: readonly string[] = [
  AUTHORIZATION_GROUP.INFOR,
  AUTHORIZATION_GROUP.MONTREAL,
  AUTHORIZATION_GROUP.STEFANINI
];

export const THIRD_PARTY_GROUP_IDS: readonly string[] = [
  AUTHORIZATION_GROUP.FFI_TERCEIRIZADOS
];

export function normalizeGroupId(groupId: string): string {
  return groupId.trim().toLowerCase();
}
